import type { ImportReason, MemberLevel, MemberOrigin, MemberView } from '@growup/accounts-shared';

/** Every level has its own symbol and words, never colour alone. */
export const LEVEL_LOOK: Record<MemberLevel, { symbol: string; label: string }> = {
  user: { symbol: '○', label: 'Utilizador' },
  member: { symbol: '●', label: 'Membro' },
  associate: { symbol: '★', label: 'Associado' },
};

export const ORIGIN_LABEL: Record<MemberOrigin, string> = {
  site: 'Site',
  arena: 'Arena',
  import: 'Importado',
};

/** What is missing in an imported record (docs/importacao 3.2). */
export const IMPORT_REASON_LABEL: Record<ImportReason, string> = {
  sem_nome: 'Nome',
  sem_data_nascimento: 'Data de nascimento',
  data_nascimento_a_confirmar: 'Data de nascimento a confirmar',
  menor: 'Menor: autorização do encarregado',
  sem_email: 'Email',
  email_invalido: 'Email inválido',
  email_repetido: 'Email partilhado com outra conta',
  sem_telemovel: 'Telemóvel',
  cc_incompleto: 'N.º do Cartão de Cidadão incompleto',
  cc_invalido: 'N.º do Cartão de Cidadão inválido',
  sem_morada: 'Morada',
  codigo_postal_invalido: 'Código postal inválido',
  sem_localidade: 'Localidade',
  pais_desconhecido: 'País',
  conta_desativada: 'Desativada no sistema antigo',
};

export const APPLICATION_STATUS_LABEL = {
  pending: 'Pendente',
  approved: 'Aprovado',
  rejected: 'Recusado',
  withdrawn: 'Desistiu',
} as const;

export const FEE_PLAN_LABEL = {
  annual: 'Anual',
  annual_jersey: 'Anual + camisola',
  monthly: 'Mensal',
} as const;

export const FEE_SOURCE_LABEL = { store: 'Loja', manual: 'À mão', import: 'Importação' } as const;

/** `AAAA-MM-DD` as `DD/MM/AAAA`, without going through a time zone. */
export function formatDay(day: string): string {
  const [y, m, d] = day.split('-');
  return `${d ?? ''}/${m ?? ''}/${y ?? ''}`;
}

export function formatEuros(cents: number): string {
  return new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' }).format(cents / 100);
}

/** The name when the viewer may read it; otherwise only the login is shown. */
export function displayName(member: MemberView): string {
  return member.profile?.fullName ?? member.login;
}

/** First and last name only, so long names fit the list ("Maria Inês da Costa Ferreira" → "Maria Ferreira"). */
export function shortName(fullName: string): string {
  const parts = fullName.trim().split(/\s+/).filter(Boolean);
  return parts.length <= 2 ? parts.join(' ') : `${parts[0] ?? ''} ${parts[parts.length - 1] ?? ''}`;
}
